<template>
  <main-template>
    <v-container>
      <v-row align="center" class="mb-1">
        <v-col>
          <h1>
            <v-btn color="primary" x-small text @click="$router.go(-1)">
              <v-icon left>fa fa-angle-left</v-icon>
            </v-btn>
            Configurações
          </h1>
        </v-col>
      </v-row>

      <div v-for="grupo in grupos" :key="grupo.nome" class="mb-6">
        <div class="config-grupo mb-3">{{ grupo.nome }}</div>
        <v-row>
          <v-col v-for="item in grupo.itens" :key="item.titulo" cols="12" sm="6" md="4">
            <v-card :to="item.to" outlined class="config-card fill-height">
              <v-card-text class="d-flex align-start">
                <div class="config-card-icone mr-4">
                  <v-icon color="var(--brand)">{{ item.icone }}</v-icon>
                </div>
                <div>
                  <div class="config-card-titulo">{{ item.titulo }}</div>
                  <div class="config-card-descricao mt-1">{{ item.descricao }}</div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <v-alert v-if="!grupos.length" type="info" text>
        Nenhuma configuração disponível para o seu perfil.
      </v-alert>
    </v-container>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";

// Central das configurações do sistema. Cada item abre a sua tela; quem vê cada item segue
// as mesmas regras de perfil, permissão e módulo das rotas.
const ITENS = [
  {
    grupo: "Sistema",
    titulo: "Módulos por perfil",
    descricao: "Quais módulos aparecem para cada perfil nesta franquia.",
    icone: "mdi-view-grid-outline",
    to: { name: "administracao.configuracoes.modulos" },
    roles: ["admin", "super-admin", "TI"],
  },
  {
    grupo: "Sistema",
    titulo: "Aparelhos de Reconhecimento Facial",
    descricao: "Aparelhos que enviam os registros de ponto e a franquia de cada um.",
    icone: "mdi-face-recognition",
    to: { name: "administracao.aparelhos" },
    roles: ["admin", "super-admin"],
  },
  {
    grupo: "Ponto",
    titulo: "Permissões de Registro Remoto",
    descricao: "Quem pode pedir registro remoto e em quais dias da semana.",
    icone: "mdi-map-marker-check-outline",
    to: { name: "colaboradores.batidasRemotas.regras" },
    roles: ["admin", "super-admin", "TI", "lider"],
    permissions: ["colaboradores.batidasRemotas.gerenciar"],
    modulo: "aprovar_remotos",
  },
  {
    grupo: "Pessoal",
    titulo: "Minhas Notificações",
    descricao: "Quais avisos você recebe por e-mail e no sistema.",
    icone: "mdi-bell-cog-outline",
    to: { name: "administracao.minhasNotificacoes" },
    roles: ["admin", "super-admin", "TI", "lider"],
  },
];

export default {
  name: "ConfiguracoesPage",
  computed: {
    ...mapGetters("Auth", ["user"]),
    ...mapGetters("AppConfigurations", ["moduloAtivo"]),
    perfis() {
      const roles = (this.user?.roles || []).map((r) => r.name);
      if (this.user?.roleName) roles.push(this.user.roleName);
      return roles;
    },
    grupos() {
      const grupos = [];
      ITENS.filter((item) => this.podeVer(item)).forEach((item) => {
        let grupo = grupos.find((g) => g.nome === item.grupo);
        if (!grupo) {
          grupo = { nome: item.grupo, itens: [] };
          grupos.push(grupo);
        }
        grupo.itens.push(item);
      });
      return grupos;
    },
  },
  methods: {
    podeVer(item) {
      if (!item.roles.some((r) => this.perfis.includes(r))) return false;
      if (item.modulo && !this.moduloAtivo(item.modulo)) return false;
      if (!item.permissions || this.user?.roleName === "super-admin") return true;
      return item.permissions.some((p) => this.user?.permissions?.includes(p));
    },
  },
};
</script>

<style scoped>
.config-grupo {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--text-muted);
}

.config-card {
  border-radius: 12px !important;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.config-card:hover {
  border-color: var(--brand) !important;
  box-shadow: 0 6px 18px rgba(var(--brand-rgb, 79, 0, 143), 0.12) !important;
}

.config-card-icone {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 40px;
  height: 40px;
  border-radius: 10px;
  background: var(--brand-soft);
}

.config-card-titulo {
  font-size: 15px;
  font-weight: 700;
  color: var(--text);
}

.config-card-descricao {
  font-size: 13px;
  line-height: 1.4;
  color: var(--text-muted);
}
</style>
